import React from "react";
import Link from "../Link";
import "./BackButton.css"


const BackButton = (props) => {
    const {backPage} = props;

    return (
        <Link href={backPage}>
            <button className="back-button">Back</button>
        </Link>
    );
};
export default BackButton;